module.exports = __webpack_public_path__ + "img/perks_E Food and Bev 1.5ca8d951.jpg";